var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "table-wrapper" }, [
      _c("table", { staticClass: "table table-bordered" }, [
        _c("thead", [
          _vm.startDate
            ? _c(
                "tr",
                [
                  _c("td", { staticClass: "sticky-col" }, [
                    _vm._v("\n                        Start date: "),
                    _c(
                      "span",
                      {
                        staticClass: "font-italic pointer",
                        attrs: {
                          title:
                            "Dated labels align project periods (e.g., months, quarters, or years) with calendar dates based on the project start date.",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.startDateLabel) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.columns, function (col) {
                    return _c(
                      "td",
                      {
                        key: col.Index,
                        staticClass: "period-col",
                        class: col.CssClass,
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(col.DatedLabel) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "tr",
            [
              _c("th", { staticClass: "sticky-col" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.title) +
                    "\n                    "
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.columns, function (col) {
                return _c("th", { key: col.Index, staticClass: "period-col" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(col.Label) +
                      "\n                    "
                  ),
                ])
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.regularSeries, function (s) {
            return _c(
              "tr",
              { key: s.Id },
              [
                _c("td", { staticClass: "sticky-col" }, [
                  _c("span", [_vm._v(_vm._s(s.Name))]),
                  _vm._v(" "),
                  s.Unit
                    ? _c("span", [_vm._v("[" + _vm._s(s.Unit) + "]")])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm._l(_vm.columns, function (col) {
                  return _c(
                    "td",
                    { key: col.Index, staticClass: "period-col" },
                    [_c("span", [_vm._v(_vm._s(s.FormattedValues[col.Index]))])]
                  )
                }),
              ],
              2
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.totalSerie
          ? _c("tfoot", [
              _c(
                "tr",
                [
                  _c("th", { staticClass: "sticky-col" }, [
                    _c("span", [_vm._v(_vm._s(_vm.totalSerie.Name))]),
                    _vm._v(" "),
                    _vm.totalSerie.Unit
                      ? _c("span", [
                          _vm._v("[" + _vm._s(_vm.totalSerie.Unit) + "]"),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.columns, function (col) {
                    return _c(
                      "td",
                      { key: col.Index, staticClass: "period-col" },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.totalSerie.FormattedValues[col.Index])
                          ),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm.totalSerie.ShowGrowthValues
                ? _c(
                    "tr",
                    [
                      _c("th", { staticClass: "sticky-col" }, [
                        _vm._v(
                          "\n                        % Growth\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.columns, function (col) {
                        return _c(
                          "td",
                          { key: col.Index, staticClass: "period-col" },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.totalSerie.FormattedGrowthValues[
                                    col.Index
                                  ]
                                )
                              ),
                            ]),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }